<span class="fw-bold">{{ label }}</span>
<button type="button" *ngIf="closeable" (click)="close()" [disabled]="disabled">
  <rrs-icon [icon]="iconTypeList.CLOSE" class="ms-2" size="12"></rrs-icon>
</button>
